import { render, staticRenderFns } from "./DocRead.vue?vue&type=template&id=67166d3c&scoped=true"
import script from "./DocRead.vue?vue&type=script&lang=js"
export * from "./DocRead.vue?vue&type=script&lang=js"
import style0 from "./DocRead.vue?vue&type=style&index=0&id=67166d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67166d3c",
  null
  
)

export default component.exports